import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { NGXLogger } from 'ngx-logger';
import { NavUrls } from '../enums/nav-urls';
import { ErrorDto } from '../model/ErrorDto';

// import { AlertService } from '../services/alert.service';
import { ExaExceptionCode } from '../enums/exaexceptioncode';
import { ExaException } from '../enums/exaexception';
import { AlertDialogButtonClick, AlertService } from './alert.service';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  className = 'ErrorHandlerService';
  urlLogin = NavUrls.ROOT + NavUrls.LOGIN;
  //urlHome = NavUrls.ROOT + NavUrls.HOME;

  showErrorOneTime = false;

  showErrorDialogs = true;

  constructor(
    private alertController: AlertController,
    private log: NGXLogger,
    private alertService: AlertService,
    private router: Router
  ) {}

  isErrorRequireNewLogin(error: ExaException) {
    if (
      error.code === ExaExceptionCode.ACCESS_UNAUTHORIZED ||
      error.code === ExaExceptionCode.SERVICE_AUTHENTICATION_ANOTHER_USER_LOGGED_IN_WITH_SAME_ACCOUNT
    ) {
      return true;
    }
    return false;
  }

  parseResponseError(responseError: HttpErrorResponse): ExaException {
    let error: ExaException = { code: 0, message: '' };
    this.log.debug(this.className + '- Response Error:', responseError);
    if (responseError.status === 500) {
      // Exa Error
      let ret = responseError.error;
      if (typeof ret === 'string') {
        ret = JSON.parse(ret);
      }
      error = { code: ret.code, message: ret.message };
      if (ret.args) {
        error.args = ret.args;
      }
    } else if (responseError.status === 401) {
      error = { code: ExaExceptionCode.ACCESS_UNAUTHORIZED, message: 'Sie sind nicht angemeldet!' };
    } else if (responseError.status === 403) {
      error = { code: ExaExceptionCode.ACCESS_FORBIDDEN, message: 'Sie sind nicht berechtigt!' };
    } else {
      // Other technical errors
      error.message = 'Es ist ein technischer Fehler aufgetreten. Bitte wenden Sie sich an den Support.';
    }
    return error;
  }

  handleResponseError(responseError: HttpErrorResponse) {
    const error = this.parseResponseError(responseError);
    console.log('ErrorHandlerService.handleResponseError', error);
    console.log(this.showErrorDialogs);
    
    
    //    this.showExaError(error);
    if (this.showErrorDialogs) {
      // if (this.isErrorRequireNewLogin(error)) {
      //   this.showErrorDialogs = false;
      // }
      let message: string = 'EXCEPTION.' + error.code; //this.translate.instant('EXCEPTION.'+error.code);

      if (message.startsWith('EXCEPTION.')) {
        message = error.message;
      } else {
        message =  message;
      }
      this.alertService.presentError(message).then((buttonClick) => {
        if (buttonClick == AlertDialogButtonClick.OK) {
          if (this.isErrorRequireNewLogin(error)) {
            this.router.navigate([this.urlLogin]);
          }
        }
      });
    }
    return error;
  }

  public async handleHttpError(response: HttpErrorResponse) {
    const errDto = this.parseErrorDto(response);
    let msg = 'Keine Verbindung Zum Server! versuchen Sie es Bitte erneut';
    if (errDto) {
      msg = errDto.message;
    }
    if (response.status === 401) {
      //show only one time and navigate back to login
      await this.showErrorOnce('Sie müssen sich erneut anmelden!');
      this.router.navigateByUrl('/' + NavUrls.LOGIN);
      // Woul be better if its not circular dependency
      // this.authService.logout();
    } else if (errDto == null) {
      await this.showErrorOnce(msg);
    } else {
      this.showError(msg);
    }
  }

  private async showError(msg: string) {
    const alert = await this.alertController.create({
      header: 'Fehler',
      subHeader: '',
      message: msg,
      buttons: ['OK'],
    });
    await alert.present();
    const { role } = await alert.onDidDismiss();
  }

  private async showErrorOnce(msg: string) {
    if (!this.showErrorOneTime) {
      this.showErrorOneTime = true;
      await this.showError(msg);
      setTimeout(() => {
        this.showErrorOneTime = false;
      }, 2000);
    }
  }

  private parseErrorDto(response: HttpErrorResponse): ErrorDto {
    this.log.debug('Try to parse ErrorDto from HttpErrorResponse', response);
    let ret: ErrorDto = null;
    if (response.status === 500) {
      //Busines Exception
      ret = this.getErrorDto(response.error);
    } else if (response.status === 401) {
      ret = this.getErrorDto(response.error);
    } else if (response.status === 403) {
      ret = this.getErrorDto(response.error);
    }
    this.log.debug('ErrorDto is', ret);
    return ret;
  }

  private getErrorDto(obj): ErrorDto {
    const ret: ErrorDto = { code: obj.code, message: obj.message, args: obj.args };
    return ret;
  }
}
